import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckCircle, Clock, Mail, Home, ChevronRight, Gift, Sparkles, Star } from 'lucide-react';
import './RegistrationSuccess.css';

const RegistrationSuccess = ({ onClose }) => {
    const [countdown, setCountdown] = useState(5);
    const [showButton, setShowButton] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [slideTransition, setSlideTransition] = useState(false);
    const navigate = useNavigate();

    const goToHome = () => {
        if (onClose) {
            onClose();
        } else {
            // Si no hay onClose (como cuando se accede directamente por URL), redirigir al inicio
            navigate('/');
        }
    };

    const nextSlide = () => {
        setSlideTransition(true);
        setTimeout(() => {
            setCurrentSlide(1);
            setSlideTransition(false);
        }, 300);
    };

    useEffect(() => {
        window.scrollTo(0, 0);

        // Animación de entrada
        setTimeout(() => setIsVisible(true), 100);

        // Countdown automático
        const countdownInterval = setInterval(() => {
            setCountdown((prev) => {
                if (prev <= 1) {
                    clearInterval(countdownInterval);
                    setShowButton(true);
                    return 0;
                }
                return prev - 1;
            });
        }, 1000);

        return () => {
            clearInterval(countdownInterval);
        };
    }, []);

    return (
        <div className={`success-page ${isVisible ? 'visible' : ''}`}>
            <div className={`success-card ${slideTransition ? 'transitioning' : ''}`}>
                {currentSlide === 0 ? (
                    <>
                        {/* Slide 1: Confirmación de registro */}
                        <div className="success-icon-container">
                            <div className="success-icon">
                                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <circle cx="12" cy="12" r="10" className="circle-bg"/>
                                    <path className="checkmark" d="M8 12l2 2 4-4" strokeLinecap="round" strokeLinejoin="round"/>
                                </svg>
                            </div>
                        </div>

                        <div className="success-content">
                            <h1 className="success-title">
                                ¡Registro Finalizado!
                            </h1>

                            <div className="success-message">
                                <p className="main-message">
                                    Tu perfil profesional ha sido recibido exitosamente
                                </p>
                                <p className="sub-message">
                                    Nuestro equipo revisará tu información y te notificaremos por email cuando esté listo.
                                </p>
                            </div>

                            {/* Información de proceso compacta */}
                            <div className="process-info">
                                <div className="process-step">
                                    <div className="step-icon completed"><CheckCircle size={14} /></div>
                                    <span>Recibido</span>
                                </div>
                                <div className="process-divider"></div>
                                <div className="process-step">
                                    <div className="step-icon pending"><Clock size={14} /></div>
                                    <span>En revisión</span>
                                </div>
                                <div className="process-divider"></div>
                                <div className="process-step">
                                    <div className="step-icon future"><Mail size={14} /></div>
                                    <span>Notificación</span>
                                </div>
                            </div>

                            {/* Preview compacto */}
                            <div className="next-step-preview">
                                <div className="preview-badge">
                                    <Sparkles size={14} />
                                    <span>¡Viene algo especial!</span>
                                </div>
                            </div>

                            {/* Contador y botón */}
                            <div className="action-section">
                                {!showButton ? (
                                    <div className="countdown-container">
                                        <div className="countdown-circle">
                                            <span className="countdown-number">{countdown}</span>
                                        </div>
                                        <p className="countdown-text">Preparando beneficio...</p>
                                    </div>
                                ) : (
                                    <div className="button-container">
                                        <button onClick={nextSlide} className="continue-button">
                                            <span>Ver mi beneficio</span>
                                            <ChevronRight size={16} />
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </>
                ) : (
                    <>
                        {/* Slide 2: Suscripción gratuita compacta */}
                        <div className="success-icon-container">
                            <div className="success-icon subscription">
                                <div className="gift-wrapper">
                                    <Gift size={28} />
                                    <div className="sparkle-effect">
                                        <Star size={10} className="sparkle sparkle-1" />
                                        <Star size={8} className="sparkle sparkle-2" />
                                        <Star size={9} className="sparkle sparkle-3" />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="success-content">
                            <h1 className="success-title subscription-title">
                                ¡Suscripción Gratuita!
                            </h1>

                            <div className="success-message">
                                <p className="main-message">
                                    Una vez que tu verifiquemos tu perfil, se activará automáticamente y pasarás a formar parte de la comunidad <span style={{fontFamily:"Montserrat", fontWeight:"600"}}> CONTACTAME</span>:
                                </p>
                            </div>
                            {/* Beneficios en grid compacto */}
                            <div className="benefits-grid">
                                <div className="benefit-item">
                                    <CheckCircle size={14} />
                                    <span>Mostrá tu trabajo y ganá visibilidad dentro de las zonas que cubrís</span>
                                </div>
                                <div className="benefit-item">
                                    <CheckCircle size={14} />
                                    <span>Toda tu información disponible para compartir o exportar a imagen</span>
                                </div>
                                <div className="benefit-item">
                                    <CheckCircle size={14} />
                                    <span>Contacto directo con tus potenciales clientes</span>
                                </div>
                            </div>

                            <div className="subscription-highlight">
                                <div className="highlight-content">
                                    <Sparkles size={18} />
                                    <p>¡Todo tuyo desde la activación!</p>
                                </div>
                            </div>

                            <div className="action-section">
                                <div className="button-container">
                                    <button onClick={goToHome} className="home-button premium">
                                        <Home size={16} />
                                        <span>Volver al inicio</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </>
                )}

                {/* Indicador de progreso */}
                <div className="slide-indicators">
                    <div className={`indicator ${currentSlide === 0 ? 'active' : 'completed'}`}></div>
                    <div className={`indicator ${currentSlide === 1 ? 'active' : ''}`}></div>
                </div>
            </div>
        </div>
    );
};

export default RegistrationSuccess;
